module.exports = __webpack_public_path__ + "media/images/whatsapp-5000eb0c312a8525b03ae424274d5c50.png";